import React, {FC} from 'react'
import {CellPropsType} from './cellPropsType'

const AppVersion: FC<CellPropsType> = ({cell}) => {
  const value = cell.getValue()

  return <>{value}</>
}

export default AppVersion
